import { useMutation } from "@shared/lib/hooks";
import { OrganisationService } from "../services/organisation.service";
import { IEditFinanceSpocsRequest } from "../types";

export default function useEditFinanceSpocs(handleSuccess: () => void) {
  const {
    mutate: editFinanceSpocs,
    isLoading: isEditFinanceSpocsLoading,
    isSuccess: isEditFinanceSpocsSuccess,
    error: editFinanceSpocsError,
    variables,
  } = useMutation({
    mutationFn: (payload: IEditFinanceSpocsRequest) =>
      OrganisationService.editFinanceSpocs(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      handleSuccess();
    },
  });

  return {
    editFinanceSpocs,
    isEditFinanceSpocsLoading,
    editFinanceSpocsError,
    isEditFinanceSpocsSuccess,
    editFinanceSpocsVariables: variables,
  };
}
